export const paymentMethodCardData = [
  {
    cardHolder: "Mathew Thamos",
    cardNumber: "1234567891233090",
    expirationDate: "09/29",
  },
];
